import script from "./XuTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./XuTitle.vue?vue&type=script&setup=true&lang=js"

import "./XuTitle.vue?vue&type=style&index=0&id=359753b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359753b8"]])

export default __exports__